interface ErrorProps {
  message: string
}

export function Error({ message }: ErrorProps) {
  return <div>{message}</div>
}
